<mat-radio-group
  class="d-block mb-16 mt-16"
  [required]="required"
  [formControl]="ngControl?.control"
  [fbDisableControl]="disable || readonly"
>
  <ng-container *ngIf="dataStorage?.dataSource as list$; else simpleList">
    <mat-radio-button *ngFor="let option of list$ | async" class="mr-16" color="primary" [value]="option?.value">
      {{ option?.label }}
    </mat-radio-button>
  </ng-container>
  <ng-template #simpleList>
    <mat-radio-button *ngFor="let option of options" class="mr-16 mb-16" color="primary" [value]="option?.value">
      {{ option?.label }}
    </mat-radio-button>
  </ng-template>
</mat-radio-group>
